<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Rekap Nilai Taruna'">
          <template v-slot:body>
            <b-form class="mt-3 mb-7">
              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-2">
                      <label>
                        Pilih Prodi
                      </label>
                    </div>
                    <div class="col-lg-6">
                      <SelectProdi :selectedValue="id_prodi" :changeprodi="changeprodi"></SelectProdi>
                    </div>
                  </div>
                </div>
              </div>
            </b-form>
            <v-card class="p-4">
              
              <div class="card-nilai cumlaude d-flex justify-content-between">
                <div class="judul">
                  CUMLAUDE
                </div>
                <div class="total-btn d-flex justify-content-between align-items-center">
                  <div class="total d-flex align-items-center">
                    <!-- 100 siswa -->
                    <div class="angka">{{result.cumlaude}}</div>
                    <div class="siswa">Siswa</div>
                  </div>
                  <div class="button d-flex justify-content-center align-items-center">
                    <i class="fas fa-angle-right" style="color: #000000; font-size: 30px;" ></i>
                  </div>
                </div>
              </div>
              <div class="card-nilai memuaskan d-flex justify-content-between">
                <div class="judul">
                  MEMUASKAN
                </div>
                <div class="total-btn d-flex justify-content-between align-items-center">
                  <div class="total d-flex align-items-center">
                    <!-- 100 siswa -->
                    <div class="angka">{{ result.memuaskan }}</div>
                    <div class="siswa">Siswa</div>
                  </div>
                  <div class="button d-flex justify-content-center align-items-center">
                    <i class="fas fa-angle-right" style="color: #000000; font-size: 30px;" ></i>
                  </div>
                </div>
              </div>
              <div class="card-nilai sangat-memuaskan d-flex justify-content-between">
                <div class="judul">
                  BAIK
                </div>
                <div class="total-btn d-flex justify-content-between align-items-center">
                  <div class="total d-flex align-items-center">
                    <!-- 100 siswa -->
                    <div class="angka">{{ result.baik }}</div>
                    <div class="siswa">Siswa</div>
                  </div>
                  <div class="button d-flex justify-content-center align-items-center">
                    <i class="fas fa-angle-right" style="color: #000000; font-size: 30px;" ></i>
                  </div>
                </div>
              </div>
              <div class="card-nilai kurang d-flex justify-content-between">
                <div class="judul">
                  KURANG
                </div>
                <div class="total-btn d-flex justify-content-between align-items-center">
                  <div class="total d-flex align-items-center">
                    <!-- 100 siswa -->
                    <div class="angka">{{result.kurang}}</div>
                    <div class="siswa">Siswa</div>
                  </div>
                  <div class="button d-flex justify-content-center align-items-center">
                    <i class="fas fa-angle-right" style="color: #000000; font-size: 30px;" ></i>
                  </div>
                </div>
              </div>
            </v-card>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/nilaiSiswa.css";
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SelectProdi from "@/view/content/components/select/SelectProdi.vue"
import axios from "axios";

export default {
  data() {
    return {
      
      id_prodi: null,
      result : {
          cumlaude  : null,
          memuaskan : null,
          baik      : null,
          kurang    : null
      },
    }
  },
  components: {
    KTCodePreview,
    SelectProdi
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Rekap" },
      { title: "Nilai Taruna" }
    ])
    // this.getNilaiAkhirByProdi()
  },
  methods: {
    changeprodi(selected) {
      this.id_prodi = selected;
      this.getNilaiAkhirByProdi(this.id_prodi);
    },

    async getNilaiAkhirByProdi(){
        try{

          await axios.get(`penilaian-akademik-new/count/${this.id_prodi}`).then(response => {
              if(response.status == 200){
                  this.result.cumlaude  = response.data.data.cumlaude;
                  this.result.memuaskan = response.data.data.memuaskan;
                  this.result.baik      = response.data.data.baik;
                  this.result.kurang    = response.data.data.kurang;
              }
          })

        }catch(err){
          this.$swal(`Failed`);
        }
    }
  }
}
</script>